module.exports = __webpack_public_path__ + "static/NadaZlajaLogo-9524d0e4bfdfc0844235b4d3a9803349.png";